import React from "react";
import classes from "./LoaderComp.module.css";

export default function LoaderComp() {
  return (
    <div className={classes.loaderWrapper}>
      <div className={classes.cubeWrapper}>
        <div className={classes.cube}></div>
        <div className={classes.cube}></div>
        <div className={classes.cube}></div>
        <div className={classes.cube}></div>
      </div>
    </div>
  );
}
